module.exports = __webpack_public_path__ + "static/media/AshevilleFarmsbillheadstylelogo2019.1fb5e267.webp";